import { Component } from 'react';
import i18n from '../../i18nextConfig';

class Language extends Component {
    constructor() {
        super();

        this.changeLanguage = this.changeLanguage.bind(this);

        this.languages = [
            { label: 'EN', key: 'en', img: '/static/img/english_icon.webp' },
            { label: 'FR', key: 'fr', img: '/static/img/french_icon.webp' },
            { label: 'ES', key: 'es', img: '/static/img/spanish_icon.webp' },
            { label: 'DE', key: 'de', img: '/static/img/german_icon.webp' },
        ];

        this.state = {
            selectedLanguage: localStorage.getItem('i18n-key') ?? 'en',
        };
    }

    changeLanguage(key) {
        i18n.changeLanguage(key);
        localStorage.setItem('i18n-key', key);

        this.setState({
            selectedLanguage: key,
        });
    }

    render() {
        const selectedOne = this.languages.find((item) => item.key === this.state.selectedLanguage);
        return (
            <div className="dropdown ">
                <a
                    className="list-group-item-action language-translation"
                    href="#"
                    role="button"
                    id="dropdownLanguage"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    <div className="language-item header">
                        <span>{selectedOne?.label}</span>
                        <img src={selectedOne?.img} alt="language" />
                        <i className="icon-arrow-down" />
                    </div>
                </a>
                <ul
                    className="dropdown-menu settings-menu language-menu"
                    aria-labelledby="dropdownLanguage"
                >
                    {this.languages.map((item) => (
                        <li key={item.key}>
                            <button
                                className={`dropdown-item ${
                                    this.state.selectedLanguage === item.key
                                        ? 'active-language'
                                        : ''
                                }`}
                                onClick={() => this.changeLanguage(item.key)}
                            >
                                <div className="language-item">
                                    <img src={item?.img} alt="language" />
                                    <span>{item?.label}</span>
                                </div>
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default Language;
